import { WHITE_LABELING } from '@/graphql/queries';
import { request } from '@/graphql/request';
import { useQuery } from '@tanstack/react-query';

const queryKey = ['WHITE_LABELING'];

/**
 * Mimic behavior of webapp-v2
 * @see https://bitbucket.org/skandio/skand.webapp-v2/src/88a76a19da4da3aa0355080ce4e852697f6e21a6/src/pages/App/app.js#lines-87
 */
export const useWhiteLabeling = () => {
  const response = useQuery({
    queryFn: () => request(WHITE_LABELING),
    queryKey,
  });

  const hasWhiteLabeling =
    response.data?.readAccountByContext?.branding?.isActive &&
    (response.data?.readAccountByContext?.branding?.webappBannerFileId ??
      response.data?.userByAccountId?.account?.bannerLogoStorageId);

  return { hasWhiteLabeling };
};

useWhiteLabeling.queryKey = queryKey;
